<ion-content [fullscreen]="true">
  <h1><b>404</b>: {{ '404.title' | transloco }}</h1>
  <p>{{ '404.doesNotExist' | transloco }}</p>
  <p>{{ '404.errorLogged' | transloco }}</p>

  <ion-button color="primary" routerLink="/translate">
    {{ '404.goHome' | transloco }}
  </ion-button>
</ion-content>
